var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('sales-delivery-form',{attrs:{"loading":_vm.loading,"salesDeliveryData":_vm.salesDelivery,"formErrors":_vm.formErrors},on:{"salesDeliveriesubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }